import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/action/paged', {
    params: toQuery(params),
  });
}

export async function queryListInformation(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function updateActionsDiagramPositions({ processId, versionId, token, data }) {
  return request(`/process/config/${processId}/${versionId}/diagram/actions?token=${token}`, {
    method: 'PATCH',
    data: data,
  });
}

export async function queryListPermissions(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySavePermission(payload) {
  return request.post(`${payload.url}`, {
    data: payload.data,
  });
}
